import type { ValueGetterParams } from 'ag-grid-community';
import type { ApproveType } from '../../../types/approval';

/**
 * 組織名と組織詳細から表示用組織名を返す
 * @param [ValueGetterParams]
 * @returns [string] - 商社コードの配列
 */
const organizationNameValueGetter = (params: ValueGetterParams): string => {
  const data: ApproveType = params.data;
  const organizationBaseName: string = data.organizationBaseName;
  const organizationSuffixName: string = data.organizationSuffixName;
  const organizationName: string = organizationBaseName + ' ' + organizationSuffixName;
  // console.log(organizationName);
  return organizationName;
};

export default organizationNameValueGetter;
